namespace $.$$ {

	export class $shm_ba_filter_section extends $.$shm_ba_filter_section {

		section_rows() {
			return [
				this.Title(),
				... this.expanded() ? this.content() : [],
			]
		}

		count_label() {
			const count = this.count()
			return count === null ? '' : `(${ count })`
		}

		filter_count() {
			return this.table()?.rows.length ?? null
		}

		@ $mol_mem
		expanded( next?: boolean ) {
			return $mol_state_local.value( this.toString() + '.expanded', next ) ?? true
		}

	}

}
